import React from 'react';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import SideContainerComponent from '../SideContainer.component';
import InfoWeCollect from './InfoCollected';
import UsePersonalInfo from './UsePersonalInfo';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import SharingPersonalInfo from './SharingPersonalInfo';
import PrivacyPolicySummary from './Summary';
import PrivacyPolicyHeader from './HeaderPrivacyPolicy';
import DataRetention from './DataRetention';
import Security from './Security';
import YourRights from './YourRights';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import PageHeader from '../../Components/PageHeader/PageHeader.component';

const PrivacyPolicy = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Privacy Policy"
        description="Read our Privacy Policy to learn how we collect, use, protect, and manage personal information when you use our website and online services."
      />
      <SideContainerComponent />
      <MainSection>
        <Breadcrumbs one="Home" oneLink="/" two="Privacy Policy" />
        <PageHeader
          eyebrow="Legal"
          title="Privacy Policy"
          desc="Learn how we collect, use, and protect your information."
        />
        <PrivacyPolicyHeader />
        <InfoWeCollect />
        <UsePersonalInfo />
        <YourRights />
        <SharingPersonalInfo />
        <Security />
        <DataRetention />
        <PrivacyPolicySummary />
      </MainSection>
    </MainContentContainer>
  );
};

export default PrivacyPolicy;
